import React, { useEffect, useRef, useState } from "react";
import UserReferenceResponse from "../../../../api/models/UserReferenceResponse";
import UserInfoApi from "../../../../api/services/UserInfoApi";
import { UserSearchAutocomplete } from "../../../../components/Autocomplete/CustomSearchAutoComplete.instances";
import useEnv from "../../../../hooks/env";
import CSCLaboratory from "../../../Admin/AdminUserOverview/CSCLaboratory";

interface SuggestedApproverInputProps {
  disabled?: boolean;
  error: boolean;
  helperText: string;
  label: string;
  laboratory: CSCLaboratory | "";
  value: UserReferenceResponse | null;
  onChange: (approver: UserReferenceResponse | null) => void;
}

const SuggestedApproverInput: React.FC<SuggestedApproverInputProps> = ({
  disabled,
  error,
  helperText,
  label,
  laboratory,
  onChange: handleChange,
  value,
}) => {
  const { api } = useEnv();
  const autocompleteRef = useRef<{ reset: (preserveInputValue?: boolean) => void }>(null);
  const userInfoApi = new UserInfoApi(api);
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      autocompleteRef.current?.reset(true);
    }
  }, [laboratory]);

  useEffect(() => {
    isMounted.current = true;
  }, []);

  return (
    <UserSearchAutocomplete
      ref={autocompleteRef}
      disabled={!!disabled}
      error={error}
      helperText={helperText}
      inputLabel={label}
      map={(data) => ({
        key: data.userEmail || "",
        label: data.userName || "",
      })}
      onChange={(e, approver) => {
        handleChange(approver);
      }}
      optionFetch={(query) => userInfoApi.getAllUsers(query, laboratory || undefined, true).then(({ data }) => data)}
      value={value}
    />
  );
};

export default SuggestedApproverInput;
